<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <ElementoItemForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ElementoItemForm from "../../../components/forms/ElementoItemForm.vue";
import { ElementoItemService } from "../../../services/ElementoItemService";

export default {
  name: "CriarElementoItem",
  components: {
    Breadcrumb,
    ElementoItemForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Elementos Itens",
          disabled: false,
          href: "/gerenciar-elementos-itens"
        },
        {
          text: "Cadastro de Elemento Item",
          disabled: true,
          href: "/elementos-itens/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_elemento_item", formData.codigoElementoItem);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await ElementoItemService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de elementos item após salvar
          this.$router.push('/gerenciar-elementos-itens');
        } else {
          throw new Error('Erro ao criar elemento item');
        }
      } catch (error) {
        console.error('Erro ao criar elemento item:', error);
        // O componente ElementoItemForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    
    handleCancel() {
      // Retornar para a tela de gerenciamento
      this.$router.push('/gerenciar-elementos-itens');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>